<template>
  <div class="partnerships">
    <HeroSection />
    <BenefitsSection />
    <HowItWorksSection />
    <PricingSection v-if="false" />
    <CtaSection />
    <TestimonialsSection />
    <FaqSection />
    <PartnerFormSection />
  </div>
</template>

<script setup>
import FaqSection from './FaqSection.vue'
import CtaSection from './CtaSection.vue'
import HeroSection from './HeroSection.vue'
import PricingSection from './PricingSection.vue'
import BenefitsSection from './BenefitsSection.vue'
import HowItWorksSection from './HowItWorksSection.vue'
import TestimonialsSection from './TestimonialsSection.vue'
import PartnerFormSection from './PartnerFormSection.vue'
</script>

<style lang="scss" scoped>
.partnerships {
  color: white;
  overflow: hidden;
}
</style>
